'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = require('prop-types');
var PropTypes__default = _interopDefault(PropTypes);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_isinteger = isInteger;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    @media ", " {\n      ", "\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var THEME_CONF = 'flexboxgrid';
var BASE_CONF = {
  gridSize: 12,
  gutterWidth: 1,
  outerMargin: 2,
  mediaQuery: 'only screen',
  container: {
    sm: 46,
    md: 61,
    lg: 76
  },
  breakpoints: {
    xs: 0,
    sm: 48,
    md: 64,
    lg: 75
  }
};
var configCache = [];

var makeCacheId = function makeCacheId(props) {
  return JSON.stringify(props.theme && props.theme[THEME_CONF] || {});
};

var resolveConfig = function resolveConfig(props) {
  var themeConf = props.theme && props.theme[THEME_CONF] || {};

  var conf = _objectSpread2({}, BASE_CONF, {}, themeConf, {
    container: _objectSpread2({}, BASE_CONF.container, {}, themeConf.container),
    breakpoints: _objectSpread2({}, BASE_CONF.breakpoints, {}, themeConf.breakpoints)
  });

  conf.media = Object.keys(conf.breakpoints).reduce(function (media, breakpoint) {
    var breakpointWidth = conf.breakpoints[breakpoint];
    media[breakpoint] = makeMedia([conf.mediaQuery, breakpoint !== 0 && "(min-width: " + breakpointWidth + "em)"].filter(Boolean).join(' and '));
    return media;
  }, {});
  return conf;
};

var DIMENSION_NAMES = ['xs', 'sm', 'md', 'lg'];
function config(props) {
  var cacheId = makeCacheId(props);

  if (configCache[0] === cacheId) {
    return configCache[1];
  }

  var conf = resolveConfig(props);
  configCache[0] = cacheId;
  configCache[1] = conf;
  return conf;
}

function makeMedia(media) {
  return function () {
    return styled.css(_templateObject(), media, styled.css.apply(void 0, arguments));
  };
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n        width: ", "rem;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: ", ";\n  padding-left: ", ";\n\n  ", "\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var Grid = styled__default.div(_templateObject$1(), function (p) {
  return config(p).outerMargin + 'rem';
}, function (p) {
  return config(p).outerMargin + 'rem';
}, function (p) {
  return !p.fluid && styled.css(_templateObject2(), DIMENSION_NAMES.map(function (t) {
    return config(p).container[t] && config(p).media[t](_templateObject3(), function (p) {
      return config(p).container[t];
    });
  }));
});
Grid.displayName = 'Grid';
Grid.propTypes = {
  fluid: PropTypes__default.bool,
  children: PropTypes__default.node
};

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n    order: 1;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n    order: -1;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: space-between;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: space-around;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    align-items: flex-end;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    align-items: center;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    align-items: flex-start;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: flex-end;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: center;\n  "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: flex-start;\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-right: ", "rem;\n  margin-left: ", "rem;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var ModificatorType = PropTypes__default.oneOf(DIMENSION_NAMES);
var Row = styled__default.div(_templateObject$2(), function (p) {
  return config(p).gutterWidth / 2 * -1;
}, function (p) {
  return config(p).gutterWidth / 2 * -1;
}, function (p) {
  return p.reverse && "\n    flex-direction: row-reverse;\n  ";
}, function (p) {
  return p.start && config(p).media[p.start](_templateObject2$1());
}, function (p) {
  return p.center && config(p).media[p.center](_templateObject3$1());
}, function (p) {
  return p.end && config(p).media[p.end](_templateObject4());
}, function (p) {
  return p.top && config(p).media[p.top](_templateObject5());
}, function (p) {
  return p.middle && config(p).media[p.middle](_templateObject6());
}, function (p) {
  return p.bottom && config(p).media[p.bottom](_templateObject7());
}, function (p) {
  return p.around && config(p).media[p.around](_templateObject8());
}, function (p) {
  return p.between && config(p).media[p.between](_templateObject9());
}, function (p) {
  return p.first && config(p).media[p.first](_templateObject10());
}, function (p) {
  return p.last && config(p).media[p.last](_templateObject11());
});
Row.displayName = 'Row';
Row.propTypes = {
  reverse: PropTypes__default.bool,
  start: ModificatorType,
  center: ModificatorType,
  end: ModificatorType,
  top: ModificatorType,
  middle: ModificatorType,
  bottom: ModificatorType,
  around: ModificatorType,
  between: ModificatorType,
  first: ModificatorType,
  last: ModificatorType,
  children: PropTypes__default.node
};

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n        margin-left: ", "%;\n      "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["", ""]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding-right: ", "rem;\n  padding-left: ", "rem;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var ModificatorType$1 = PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.bool]);
var offsetProps = DIMENSION_NAMES.map(function (d) {
  return d + 'Offset';
});
var DimensionPropTypes = DIMENSION_NAMES.reduce(function (propTypes, dimension) {
  propTypes[dimension] = ModificatorType$1;
  propTypes[dimension + 'Offset'] = PropTypes__default.number;
  return propTypes;
}, {});
var Col = styled__default.div(_templateObject$3(), function (p) {
  return config(p).gutterWidth / 2;
}, function (p) {
  return config(p).gutterWidth / 2;
}, function (p) {
  return p.reverse && "\n    flex-direction: column-reverse;\n  ";
}, function (p) {
  return Object.keys(p).filter(function (k) {
    return ~DIMENSION_NAMES.indexOf(k);
  }).sort(function (k1, k2) {
    return DIMENSION_NAMES.indexOf(k1) - DIMENSION_NAMES.indexOf(k2);
  }).map(function (k) {
    return config(p).media[k](_templateObject2$2(), lodash_isinteger(p[k]) // Integer value
    ? "\n        flex-basis: " + 100 / config(p).gridSize * p[k] + "%;\n        max-width: " + 100 / config(p).gridSize * p[k] + "%;\n        display: block;\n      " // Boolean
    : p[k] // Auto-width
    ? "\n          flex-grow: 1;\n          flex-basis: 0;\n          max-width: 100%;\n          display: block;\n        " // Hide element
    : 'display: none;');
  });
}, function (p) {
  return Object.keys(p).filter(function (k) {
    return ~offsetProps.indexOf(k);
  }).map(function (k) {
    return config(p).media[k.replace(/Offset$/, '')](_templateObject3$2(), 100 / config(p).gridSize * p[k]);
  });
});
Col.displayName = 'Col';
Col.propTypes = _objectSpread2({}, DimensionPropTypes, {
  reverse: PropTypes__default.bool,
  children: PropTypes__default.node
});

var _templateObject$4;
var StyledColumn = styled__default(Col)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  @media only screen and (min-width: ", ") {\n    display: ", ";\n  }\n  @media only screen and (min-width: ", ") {\n    display: ", ";\n  }\n  @media only screen and (min-width: ", ") {\n    display: ", ";\n  }\n  @media only screen and (min-width: ", ") {\n    display: ", ";\n  }\n  align-items: ", ";\n  justify-content: ", ";\n  flex-direction: column;\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.flexboxgrid.breakpoints.xs, "em");
}, function (_ref2) {
  var xs = _ref2.xs;
  return xs === false ? 'none' : 'flex';
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.flexboxgrid.breakpoints.sm, "em");
}, function (_ref4) {
  var sm = _ref4.sm;
  return sm === false ? 'none' : 'flex';
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.flexboxgrid.breakpoints.md, "em");
}, function (_ref6) {
  var md = _ref6.md;
  return md === false ? 'none' : 'flex';
}, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.flexboxgrid.breakpoints.lg, "em");
}, function (_ref8) {
  var lg = _ref8.lg;
  return lg === false ? 'none' : 'flex';
}, function (props) {
  return props.valign;
}, function (props) {
  return props.halign;
});

var Column = function Column(_ref) {
  var cols = _ref.cols,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      offset = _ref.offset,
      xsOffset = _ref.xsOffset,
      smOffset = _ref.smOffset,
      mdOffset = _ref.mdOffset,
      lgOffset = _ref.lgOffset,
      children = _ref.children,
      className = _ref.className,
      valign = _ref.valign,
      halign = _ref.halign;

  var colMode = function colMode(prop) {
    // if cols has been defined, and the xs - lg prop is not false or a number, set via cols prop
    if (cols && prop !== false && typeof prop !== 'number') {
      return cols;
    } // take the prop xs - lg prop if it exists


    if (prop || prop === false) {
      return prop;
    } // default to auto sizing columns


    return true;
  };

  var offsetMode = function offsetMode(prop) {
    if (offset && prop === null) {
      return offset;
    }

    return prop;
  };

  return /*#__PURE__*/React__default.createElement(StyledColumn, {
    xs: colMode(xs),
    sm: colMode(sm),
    md: colMode(md),
    lg: colMode(lg),
    xsOffset: offsetMode(xsOffset),
    smOffset: offsetMode(smOffset),
    mdOffset: offsetMode(mdOffset),
    lgOffset: offsetMode(lgOffset),
    valign: valign,
    halign: halign,
    className: "\n        ".concat(className, "\n      ")
  }, children);
};

Column.propTypes = {
  /**
   * Classes to be applied to the container element
   */
  className: PropTypes__default.string,

  /**
   * Col size for all breakpoints
   */
  cols: PropTypes__default.number,

  /**
   * Width in columns at xs screen sizes.
   * if true - enable auto sizing. If false, hide column otherwise specifiy amount of cols
   */
  xs: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.number]),

  /**
   * Width in columns at sm screen sizes.
   * if true - enable auto sizing. If false, hide column otherwise specifiy amount of cols
   */
  sm: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.number]),

  /**
   * Width in columns at md screen sizes.
   * if true - enable auto sizing. If false, hide column otherwise specifiy amount of cols
   */
  md: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.number]),

  /**
   * Width in columns at lg screen sizes.
   * if true - enable auto sizing. If false, hide column otherwise specifiy amount of cols
   */
  lg: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.number]),

  /**
   * offset for all breakpoints
   */
  offset: PropTypes__default.number,

  /**
   * Offset in columns at the xs screen size.
   */
  xsOffset: PropTypes__default.number,

  /**
   * Offset in columns at the sm screen size.
   */
  smOffset: PropTypes__default.number,

  /**
   * Offset in columns at the md screen size.
   */
  mdOffset: PropTypes__default.number,

  /**
   * Offset in columns at the lg screen size.
   */
  lgOffset: PropTypes__default.number,

  /**
   * The column contents.
   */
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node]),

  /**
   * The align-items property is related to CSS layout.
   */
  valign: PropTypes__default.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),

  /**
   * The justify-content property is related to CSS layout.
   */
  halign: PropTypes__default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'initial', 'inherit'])
};
Column.defaultProps = {
  className: '',
  cols: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  offset: null,
  xsOffset: null,
  smOffset: null,
  mdOffset: null,
  lgOffset: null,
  valign: 'stretch',
  halign: 'initial',
  children: []
};

var flexboxgrid = {
  gridSize: 12,
  // columns
  gutterWidth: 1,
  // rem
  outerMargin: 2,
  // rem
  mediaQuery: 'only screen',
  breakpoints: {
    xs: 0,
    // em
    sm: 48,
    // em or 768px
    md: 64,
    // em or 1024px
    lg: 75,
    // em or 1200px,
    xl: 90 // em or 1440px

  }
};
/**
 * These are used by ManorContext (and breakpoint hooks) to determine the breakpoint. Ranges are:
 * (see useBreakpoint.js)
 * xs: 0 - 767px
 * sm 768px - 1023px
 * md: 1024px - 1199px
 * lg: 1200px - 1439px
 * xl: 1440px+
 */

var breakpoints = {
  xs: '767px',
  sm: '1023px',
  md: '1199px',
  lg: '1439px'
};
var breakpointsNumeric = {
  xs: 767,
  sm: 1023,
  md: 1199,
  lg: 1439
};
var colors = {
  brandMidnightBlue: '#001443',
  brandDarkBlue: '#001564',
  brandLightBlue: '#0f58ab',
  primary50: '#e7f0fb',
  primary100: '#c2d9f0',
  primary200: '#90bdea',
  primary300: '#5A94CE',
  primary400: '#3b80c5',
  primary500: '#0b60b7',
  primary600: '#004a8e',
  primary700: '#063a6d',
  primary800: '#042649',
  primary900: '#021324',
  hero50: '#e7f3ea',
  hero300: '#57ad69',
  hero400: '#339c48',
  hero500: '#0f8928',
  hero600: '#0d7522',
  hero700: '#0b611c',
  grey50: '#fafafa',
  grey100: '#f6f6f6',
  grey200: '#eeeeee',
  grey300: '#E0E0E0',
  grey400: '#c4c4c4',
  grey500: '#9e9e9e',
  grey600: '#757575',
  grey700: '#616161',
  grey800: '#424242',
  grey900: '#25130e',
  black: '#000000',
  white: '#FFFFFF',
  inputDisabledTextOnGray: '#606060',
  // grey 700
  inputPlacholderText: '#757575',
  // grey 600
  inputDisabledTextOnWhite: '#9e9e9e',
  // grey 500
  inputDisabledBackground: '#f6f6f6',
  // grey 200
  inputPrefilled: '#fbf9ec',
  inputPrefilledBorder: '#c39600',
  success50: '#dbf5d6',
  success500: '#0f8a28',
  success700: '#0a5c1b',
  error50: '#fbedee',
  error100: '#fbe4e6',
  error300: '#ef425e',
  error500: '#d2202f',
  error700: '#a41925',
  warning50: '#fff6ed',
  warning100: '#f5eebc',
  warning500: '#ff901d',
  warning700: '#d66c00',
  tooltipBackgroundDark: 'rgba(37, 19, 14, 0.95)',
  // opacity colors
  black25: 'rgba(0,0,0,0.25)',
  black50: 'rgba(0,0,0,0.50)',
  black75: 'rgba(0,0,0,0.75)',
  white25: 'rgba(255,255,255,0.25)',
  white50: 'rgba(255,255,255,0.50)',
  white75: 'rgba(255,255,255,0.75)'
};
var fontFamily = '"SourceSansPro", "Helvetica", "Arial"';
var fontSize = {
  '2xs': '1rem',
  // 10px
  xs: '1.2rem',
  // 12px
  sm: '1.4rem',
  // 14px
  base: '1.6rem',
  // 16px
  lg: '1.8rem',
  // 18px
  xl: '2rem',
  // 20px
  '2xl': '2.2rem',
  // 22px
  '3xl': '2.4rem',
  // 24px
  '4xl': '2.8rem',
  // 28px
  '5xl': '3.2rem',
  // 32px
  '6xl': '4.2rem' // 42px

};
var fontWeight = {
  hairline: '100',
  thin: '200',
  light: '300',
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  extrabold: '800',
  black: '900'
};
var lineHeight = {
  none: '1',
  tighter: '1.2',
  tight: '1.25',
  snug: '1.4',
  normal: '1.5',
  relaxed: '1.625',
  loose: '2'
};
var spacing = {
  px: '0.1rem',
  //   1px
  0: '0',
  4: '0.4rem',
  8: '0.8rem',
  12: '1.2rem',
  16: '1.6rem',
  // 16px (just move the decimal place to the right one place)
  20: '2rem',
  24: '2.4rem',
  28: '2.8rem',
  32: '3.2rem',
  36: '3.6rem',
  40: '4rem',
  44: '4.4rem',
  48: '4.8rem',
  52: '5.2rem',
  56: '5.6rem',
  60: '6rem',
  64: '6.4rem',
  68: '6.8rem',
  72: '7.2rem',
  76: '7.6rem',
  80: '8rem',
  84: '8.4rem',
  88: '8.8rem',
  92: '9.2rem',
  96: '9.6rem',
  100: '10rem',
  104: '10.4rem',
  108: '10.8rem',
  112: '11.2rem',
  116: '11.6rem',
  120: '12rem',
  124: '12.4rem',
  128: '12.8rem',
  132: '13.2rem',
  136: '13.6rem',
  140: '14rem',
  144: '14.4rem',
  148: '14.8rem',
  152: '15.2rem',
  156: '15.6rem',
  160: '16rem',
  164: '16.4rem',
  168: '16.8rem',
  172: '17.2rem',
  176: '17.6rem',
  180: '18rem',
  184: '18.4rem',
  188: '18.8rem',
  192: '19.2rem',
  196: '19.6rem',
  200: '20rem',
  204: '20.4rem',
  208: '20.8rem',
  212: '21.2rem',
  216: '21.6rem',
  220: '22rem',
  224: '22.4rem',
  228: '22.8rem',
  232: '23.2rem',
  236: '23.6rem',
  240: '24rem',
  244: '24.4rem',
  248: '24.8rem',
  252: '25.2rem',
  256: '25.6rem',
  280: '28rem',
  360: '36rem',
  600: '60rem'
};
var borderRadius = {
  none: '0',
  sm: '0.2rem',
  //    2x
  default: '0.4rem',
  //    4px
  lg: '0.8rem',
  //    8px
  full: '999.9rem' // 9999px

};
var elevation = {
  lvl1: '0px 0.2rem 0.2rem rgba(208,206,206,0.5)',
  lvl2: '0px 0.5rem 0.8rem rgba(0,0,0,0.05)',
  lvl3: '0px 0.3rem 0.8rem rgba(0,0,0,0.1)',
  lvl4: '0px 0.3rem 0.8rem rgba(0,0,0,0.2)',
  lvl5: '0px 0.5rem 0.8rem rgba(0,0,0,0.2)',
  lvl6: '0px 0.8rem 0.8rem rgba(0,0,0,0.2)',
  none: 'none'
};
var boxShadow = {
  default: 'rgba(0, 0, 0, 0.1) 0 1rem 4rem 0',
  sm: '0 0.5rem 0.5rem 0 rgba(0,0,0,.1)',
  md: '0 0.4rem 0.8rem 0 rgba(0,0,0,0.12), 0 0.2rem 0.4rem 0 rgba(0,0,0,0.08)',
  lg: '0 1.5rem 3rem 0 rgba(0,0,0,0.11), 0 0.5rem 1.5rem 0 rgba(0,0,0,0.08)',
  inner: 'inset 0 0.2rem 0.4rem 0 rgba(0,0,0,0.06)',
  outline: '0 0 0 0.3rem rgba(52,144,220,0.5)',
  none: 'none',
  progress: '0 0.2rem 0.4rem 0 #DDDBDB',
  box: '0px 3px 8px rgba(0, 0, 0, 0.1)'
};
var maxWidth = {
  xs: '32rem',
  //  320px
  sm: '48rem',
  //  480px
  md: '64rem',
  //  640px
  lg: '80rem',
  //  800px
  xl: '96rem',
  //  960px
  '2xl': '112rem',
  // 1120px
  '3xl': '128rem',
  // 1280px
  '4xl': '144rem',
  // 1440px
  '5xl': '160rem',
  // 1600px
  '6xl': '190rem',
  // 1900px
  full: '100%'
};
var minHeight = {
  0: '0',
  full: '100%',
  screen: '100vh'
};
var minWidth = {
  0: '0',
  xs: '32rem',
  full: '100%'
};
var opacity = {
  0: '0',
  25: '0.25',
  50: '0.5',
  75: '0.75',
  100: '1'
};
var zIndex = {
  auto: 'auto',
  entry: '-1',
  max: '2147483647',
  // reserved for toast notifications
  0: '0',
  10: '10',
  20: '20',
  30: '30',
  40: '40',
  50: '50'
};
var transition = {
  default: 'all 200ms ease-out'
};
var borders = {
  invalid: "1px solid ".concat(colors.error500),
  transparent: '1px solid transparent',
  disabled: "1px solid ".concat(colors.grey300),
  component: "1px solid ".concat(colors.grey300),
  hover: "1px solid ".concat(colors.primary300),
  active: "1px solid ".concat(colors.primary500),
  prefill: "1px solid ".concat(colors.inputPrefilledBorder),
  dark: "1px solid ".concat(colors.brandMidnightBlue),
  focus: "1px solid ".concat(colors.primary500),
  expressive: "1px solid ".concat(colors.primary200)
};
var ctmTheme = {
  accordion: {
    background: colors.grey100,
    backgroundBody: colors.white,
    color: colors.grey900,
    chevronColor: colors.primary500
  },
  button: {
    borderRadius: borderRadius.default,
    fontWeight: fontWeight.bold,
    disabledBackgound: colors.grey500,
    disabledText: colors.white,
    shadows: {
      default: elevation.lvl4,
      hover: elevation.lvl5,
      focused: elevation.lvl3,
      disabled: elevation.none
    },
    hero: {
      background: colors.hero500,
      backgroundHover: colors.hero600,
      color: colors.white,
      fill: colors.white,
      backgroundInverted: colors.white,
      backgroundInvertedHover: colors.hero50,
      colorInverted: colors.hero500,
      fillInverted: colors.hero500
    },
    primary: {
      background: colors.primary500,
      backgroundHover: colors.primary600,
      color: colors.white,
      fill: colors.white,
      backgroundInverted: colors.white,
      backgroundInvertedHover: colors.primary50,
      colorInverted: colors.primary500,
      fillInverted: colors.primary500
    },
    secondary: {
      background: colors.white,
      backgroundHover: colors.primary50,
      color: colors.primary500,
      fill: colors.white,
      border: "1px solid ".concat(colors.primary500),
      backgroundInverted: colors.primary500,
      backgroundInvertedHover: colors.primary400,
      borderInverted: "1px solid ".concat(colors.white),
      colorInverted: colors.white,
      fillInverted: colors.white
    },
    tertiary: {
      background: 'transparent',
      backgroundHover: colors.primary50,
      color: colors.primary500,
      fill: colors.primary500,
      colorhover: colors.primary700
    }
  },
  card: {
    background: colors.white,
    border: borders.component,
    shadow: elevation.lvl1
  },
  checkbox: {
    color: colors.white,
    colorDisabled: colors.brandMidnightBlue,
    disabledOpacity: opacity[50],
    border: borders.component,
    borderHover: borders.hover,
    active: borders.active,
    prefilled: colors.inputPrefilled,
    prefilledBorder: "1px solid ".concat(colors.inputPrefilledBorder),
    invalid: "1px solid ".concat(colors.error500),
    iconPrefilled: colors.grey500,
    size: spacing[20],
    background: colors.white,
    backgroundChecked: colors.primary500,
    backgroundDisabled: colors.grey300,
    shadow: '0 0 0 1px rgba(0, 123, 255, .5)',
    borderRadius: borderRadius.sm,
    contentMargin: "0 ".concat(spacing[8]),
    boxedShadow: '0 3px 8px rgba(0, 0, 0, 0.1)'
  },
  container: {
    maxWidth: '120rem'
  },
  combo: {
    list: {
      color: colors.black,
      background: colors.white,
      shadow: boxShadow.md,
      item: {
        color: colors.grey700,
        backgroundHover: colors.grey100,
        borderFocus: borders.hover
      }
    },
    button: {
      border: borders.transparent,
      background: colors.primary50,
      borderFocus: borders.hover,
      backgroundHover: colors.primary50
    }
  },
  datepicker: {
    navigationButtonColor: colors.primary500,
    datepickerDayColor: colors.grey700,
    datepickerDayColorSelected: colors.white,
    datepickerDayBackground: colors.primary500,
    datepickerSelectedDayRangeColor: colors.black,
    datepickerSelectedDayRangeBackground: colors.primary50,
    datepickerSelectedDayEdgeBackground: colors.brandLightBlue,
    datepickerSelectedDayEdgeBackgroundHover: colors.primary400
  },
  dropdown: {
    height: spacing[44],
    color: colors.grey900,
    background: colors.white,
    backgroundDisabled: colors.grey100,
    disabledOpacity: '0.5',
    disabledSvgOpacity: '0.3',
    prefixBackground: colors.white,
    prefixColor: colors.grey600,
    shadow: boxShadow.box,
    caretFill: colors.primary500,
    colorActive: colors.brandLightBlue,
    backgroundActive: colors.grey100,
    list: {
      hoverBackground: colors.grey100,
      item: {
        borderFocus: borders.hover
      }
    }
  },
  emptyState: {
    containerMaxWidth: spacing[600],
    imgMaxWidth: spacing[280],
    imgMaxHeight: spacing[280]
  },
  featureList: {
    color: colors.success500
  },
  footer: {
    background: colors.white,
    transparent: 'transparent'
  },
  header: {
    background: colors.white,
    shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    height: spacing[60],
    heightStuck: spacing[44],
    contact: {
      color: colors.primary500,
      hoverColor: colors.primary600
    }
  },
  input: {
    background: colors.white,
    height: spacing[44],
    color: colors.black,
    clearButton: {
      hoverColor: colors.primary500,
      color: colors.grey300,
      colorAutofill: colors.grey500
    },
    expressive: colors.primary500,
    expressiveDisabled: colors.grey50
  },
  label: {
    color: colors.grey900,
    inField: colors.grey600
  },
  logo: {
    heightSmall: spacing[32],
    heightLarge: spacing[44]
  },
  modal: {
    maxHeight: spacing[36],
    maxWidth: '745px'
  },
  notification: {
    color: colors.grey700,
    aaColor: colors.grey800,
    shadow: elevation.lvl3,
    success: {
      color: colors.success500,
      background: colors.hero50
    },
    warning: {
      color: colors.warning500,
      background: colors.warning50
    },
    error: {
      color: colors.error500,
      background: colors.error50
    },
    general: {
      color: colors.primary500,
      background: colors.primary50
    }
  },
  placeholder: {
    fontSize: fontSize.base,
    color: colors.grey600
  },
  loading: {
    background: colors.grey300,
    primary: colors.primary500,
    secondary: colors.hero500,
    fontSize: fontSize.base,
    containerBackground: 'transparent',
    borderRadius: borderRadius.lg
  },
  progress: {
    bar: {
      background: colors.white,
      backgroundValue: colors.grey300,
      height: spacing[6],
      progressBackground: colors.primary500
    },
    icon: {
      border: "2px solid ".concat(colors.black),
      borderDisabled: "2px solid ".concat(colors.grey500),
      disabledColor: colors.grey500,
      activeColor: colors.white,
      activeBackground: colors.black
    },
    tracker: {
      background: colors.white,
      backgroundValue: colors.grey100,
      colorValue: colors.primary50,
      backgroundCss: "\n        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#cfefc2+0,c3e4cf+100 */\n        background: ".concat(colors.primary50, ";  /* Old browsers   */\n        background ", "-moz-linear-gradient(left, ".concat(colors.primary50, " 0%, ").concat(colors.primary100, "  100%)"), "; /* FF3.6-15 */   \n        background: ", "-webkit-linear-gradient(left, ".concat(colors.primary50, " 0%, ").concat(colors.primary100, "  100%)"), "; /* Chrome10-25,Safari5.1-6 */\n        background: ", "linear-gradient(to right, ".concat(colors.primary50, " 0%, ").concat(colors.primary100, "  100%)"), "; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n        filter: ", "progid:DXImageTransform.Microsoft.gradient( startColorstr=".concat(colors.primary50, ", endColorstr=").concat(colors.primary100, ",GradientType=1 )"), ";  /* IE6-9 */\n      "),
      itemLinkColor: colors.black,
      progressStep: {
        color: colors.black,
        disabledColor: colors.grey500
      },
      item: {
        border: "1px solid ".concat(colors.grey300)
      }
    }
  },
  separator: {
    border: "1px solid ".concat(colors.black25)
  },
  slider: {
    margin: "".concat(spacing[20], " ").concat(spacing[16], " 0 ").concat(spacing[16]),
    disabled: colors.grey500,
    mark: {
      fontSize: fontSize.base,
      color: colors.grey800
    },
    rail: {
      color: colors.grey500,
      height: spacing[8],
      borderRadius: spacing[4]
    },
    track: {
      color: colors.primary500,
      height: spacing[8],
      borderRadius: spacing[4]
    },
    thumb: {
      height: spacing[20],
      width: spacing[20],
      border: "0.2rem solid ".concat(colors.grey100),
      boxShadow: '0px 3px 8px rgba(0,0,0,0.1)'
    },
    notch: {
      height: spacing[8],
      border: "1px solid ".concat(colors.grey500),
      defaultIndicator: {
        height: spacing[16],
        border: "2px solid ".concat(colors.primary500)
      }
    },
    label: {
      borderRadius: spacing[4],
      padding: "".concat(spacing[4], " ").concat(spacing[8])
    }
  },
  table: {
    rowHoverBackground: colors.grey100
  },
  tabs: {
    titleFontSize: fontSize.base,
    titleFontWeight: fontWeight.semibold,
    titleColor: colors.primary900,
    background: colors.primary50,
    buttonWrapShadow: "inset 0 -0.2rem 0 ".concat(colors.primary200),
    selectedTabShadow: "inset 0 -0.2rem 0 ".concat(colors.primary500)
  },
  toggle: {
    base: {
      labelColorHover: colors.primary300,
      background: colors.white,
      backgroundChecked: colors.primary500,
      color: colors.primary500,
      colorChecked: colors.white,
      colorDisabled: colors.grey300,
      shadowHover: elevation.lvl5
    },
    button: {
      text: colors.grey900,
      disabledColor: colors.grey500
    },
    multiSelect: {
      width: '30.4rem',
      borderChecked: "2px solid ".concat(colors.primary500)
    },
    greyed: {
      background: colors.grey500,
      color: colors.white
    }
  },
  tooltip: {
    iconColor: colors.primary500,
    iconColorVisible: colors.primary600,
    titleTextColor: colors.white,
    titleTextColorDark: colors.grey900,
    bodyTextColor: colors.white,
    bodyTextColorDark: colors.grey800,
    background: colors.tooltipBackgroundDark,
    backgroundLight: colors.white
  },
  drawer: {
    borderTop: "2px solid ".concat(colors.primary200),
    background: colors.white,
    closeIcon: colors.grey500,
    shadow: '0px 0px 6px rgba(0, 0, 0, 0.15)'
  },
  compareDrawer: {
    borderTop: "5px solid ".concat(colors.primary500),
    background: colors.white
  },
  emptyCard: {
    background: colors.grey50
  },
  tag: {
    background: colors.primary50,
    alert: colors.error50,
    alertTextColor: colors.error700,
    alertHover: "1px solid ".concat(colors.error500),
    regHover: "1px solid ".concat(colors.primary300),
    height: '100px'
  },
  breakpoints: breakpoints,
  breakpointsNumeric: breakpointsNumeric,
  borders: borders,
  colors: colors,
  fontFamily: fontFamily,
  fontSize: fontSize,
  spacing: spacing,
  borderRadius: borderRadius,
  boxShadow: boxShadow,
  fontWeight: fontWeight,
  lineHeight: lineHeight,
  maxWidth: maxWidth,
  minHeight: minHeight,
  minWidth: minWidth,
  opacity: opacity,
  zIndex: zIndex,
  transition: transition,
  elevation: elevation,
  flexboxgrid: flexboxgrid
};

var spacingPropTypes = function spacingPropTypes(props, propName, componentName) {
  // eslint-disable-next-line react/destructuring-assignment
  var values = props[propName];
  var spacing = Object.keys(ctmTheme.spacing);
  if (values === undefined || values.length === 0) return null;

  if (values.length > 4) {
    throw new Error("Invalid prop value (".concat(propName, "=[").concat(props[propName], "]) supplied to ").concat(componentName, ". Max array length is 4, representing each of the css values ").concat(propName, " can receive."));
  }

  values.forEach(function (el) {
    if (!spacing.includes(el)) {
      throw new Error("Invalid prop value (".concat(propName, "=[").concat(props[propName], "]) supplied to ").concat(componentName, ". Each array item must be a multiple of 4, which is a key for the internal manor spacing."));
    }
  });
  return null;
};

var applySpacing = function applySpacing(theme, spacingType, spacingValue) {
  var validCSS = spacingValue.map(function (v) {
    return theme.spacing[v] !== undefined ? theme.spacing[v] : '0';
  });
  var parsedResult = "".concat(spacingType, ": ").concat(validCSS.join(' '));
  return parsedResult;
};

var _templateObject$5;
var StyledContainer = styled__default.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: ", ";\n  margin: auto;\n  ", ";\n  max-width: ", ";\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.maxWidth.full;
}, function (_ref2) {
  var padding = _ref2.padding,
      theme = _ref2.theme;
  return applySpacing(theme, 'padding', padding);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.container.maxWidth;
});

function getTheme(gutterWidth) {
  return {
    gridSize: 12,
    // columns
    gutterWidth: gutterWidth / 10,
    // rem
    outerMargin: 2,
    // rem
    mediaQuery: 'only screen',
    breakpoints: {
      xs: 0,
      // em
      sm: 48,
      // em or 768px
      md: 64,
      // em or 1024px
      lg: 75,
      // em or 1200px,
      xl: 90 // em or 1440px

    }
  };
}

var ThemedContainer = function ThemedContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      padding = _ref.padding,
      gutterWidth = _ref.gutterWidth,
      theme = _ref.theme;
  // eslint-disable-next-line no-param-reassign,react/prop-types
  theme.flexboxgrid = getTheme(gutterWidth);
  return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(StyledContainer, {
    className: className,
    padding: padding
  }, children));
};

var DynamicThemedContainer = styled.withTheme(ThemedContainer);

var Container = function Container(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      padding = _ref2.padding,
      gutterWidth = _ref2.gutterWidth;
  return /*#__PURE__*/React__default.createElement(DynamicThemedContainer, {
    className: className,
    padding: padding,
    gutterWidth: gutterWidth
  }, children);
};

Container.propTypes = {
  /**
   * Classes to be applied to the container element
   */
  className: PropTypes__default.string,
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.arrayOf(PropTypes__default.node)]),

  /**
   * The left and right padding to be applied to the container
   */
  padding: spacingPropTypes,

  /**
   * The spacing between grid columns
   */
  gutterWidth: PropTypes__default.oneOf([4, 8, 12, 16, 24, 32])
};
Container.defaultProps = {
  className: '',
  children: [],
  padding: ['0'],
  gutterWidth: 32
};

var _templateObject$6;
var StyledContainer$1 = styled__default.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  margin: auto;\n  ", ";\n"])), function (_ref) {
  var padding = _ref.padding,
      theme = _ref.theme;
  return applySpacing(theme, 'padding', padding);
});

var ThemedFluidContainer = function ThemedFluidContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      padding = _ref.padding,
      gutterWidth = _ref.gutterWidth,
      theme = _ref.theme;
  // eslint-disable-next-line no-param-reassign,react/prop-types
  theme.flexboxgrid = getTheme(gutterWidth);
  return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(StyledContainer$1, {
    className: className,
    padding: padding
  }, children));
};

var DynamicThemedFluidContainer = styled.withTheme(ThemedFluidContainer);

var FluidContainer = function FluidContainer(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      padding = _ref2.padding,
      gutterWidth = _ref2.gutterWidth;
  return /*#__PURE__*/React__default.createElement(DynamicThemedFluidContainer, {
    className: className,
    padding: padding,
    gutterWidth: gutterWidth
  }, children);
};

FluidContainer.propTypes = {
  /**
   * Classes to be applied to the FluidContainer element
   */
  className: PropTypes__default.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.arrayOf(PropTypes__default.node)]),

  /**
   * The left and right padding to be applied to the container
   */
  padding: spacingPropTypes,

  /**
   * The spacing between grid columns
   */
  gutterWidth: PropTypes__default.oneOf([4, 8, 12, 16, 24, 32])
};
FluidContainer.defaultProps = {
  className: '',
  children: [],
  padding: ['0'],
  gutterWidth: 32
};

var _templateObject$7;
var StyledFlexRow = styled__default(Row)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  margin-bottom: ", ";\n  ", ";\n  ", ";\n  justify-content: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
      removeMarginBottom = _ref.removeMarginBottom;
  return removeMarginBottom ? 0 : theme.spacing[24];
}, function (props) {
  return props.flexWrap && styled.css(["flex-wrap:", ";"], props.flexWrap);
}, function (props) {
  return props.reverse && styled.css(["flex-direction:row-reverse;"]);
}, function (props) {
  return props.justify;
});

var Row$1 = function Row(_ref) {
  var children = _ref.children,
      className = _ref.className,
      reverse = _ref.reverse,
      removeMarginBottom = _ref.removeMarginBottom,
      flexWrap = _ref.flexWrap,
      justify = _ref.justify;
  return /*#__PURE__*/React__default.createElement(StyledFlexRow, {
    justify: justify,
    className: "row ".concat(className),
    reverse: reverse,
    removeMarginBottom: removeMarginBottom,
    flexWrap: flexWrap
  }, children);
};

Row$1.propTypes = {
  /**
   * Classes to be applied to the row element
   */
  className: PropTypes__default.string,

  /**
   * Flex-direction: reverse bool for the row
   */
  reverse: PropTypes__default.bool,

  /**
   * The children of the component
   */
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array, PropTypes__default.object]),

  /**
   * Remove the default margin-bottom
   */
  removeMarginBottom: PropTypes__default.bool,

  /**
   * It defines whether the flex items are forced in a single line or can be flowed into multiple lines.
   */
  flexWrap: PropTypes__default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines alignment of a column
   */
  justify: PropTypes__default.oneOf(['flex-start', 'center', 'flex-end', 'space-around', 'space-between', 'initial', 'inherit'])
};
Row$1.defaultProps = {
  className: '',
  children: [],
  removeMarginBottom: false,
  reverse: false,
  flexWrap: 'wrap',
  justify: 'flex-start'
};

exports.Column = Column;
exports.Container = Container;
exports.FluidContainer = FluidContainer;
exports.Row = Row$1;
